import apiClient from '../apiClient';

let ControllerName = 'Pages';
const SeoPagesController = Object.freeze({
    SeoByCode: `${ControllerName}/seo-by-code`,
});

export const getSeoByCode = async (code) => {
  try {
    const response = await apiClient.get(`${SeoPagesController.SeoByCode}`, {
      params: { code }
    });
    return response.data; 
  } catch (error) {
    console.error('Error fetching page data:', error);
    throw error; 
  }
};
